import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ConfigProvider } from "antd";
import esES from "antd/lib/locale/es_ES";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <ConfigProvider locale={esES} theme={{
    token: {
        // Seed Token
        colorPrimary: '#244384',
        fontFamily:"Montserrat, sans serif"
    },
components: {
Layout: {
backgroundColor: '#f0f2f5',
algorithm: true, // Enable algorithm
}}
}} >
  <App />
  </ConfigProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
